export default __webpack_public_path__ + "static/media/element_spec_4.4a31747d.webp";